<p-table #sales [value]="salesHistory" responsiveLayout="scroll" [paginator]="true" [rows]="pageSize" 
[showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPage" [totalRecords]="totalRecordSales" 
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
(onPage)="onPageChange($event)" [lazy]="true">
    <ng-template pTemplate="caption">
        <div class="p-text-right">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Search" (input)="searchFilter()" [(ngModel)]="searchValueSales" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Invoice Date</th>
            <th>Invoice No.</th>
            <th>Ord Qty</th>
            <th>Shipped Qty</th>
            <th>Cost</th>
            <th>Sale Price</th>
            <th *ngIf="module == 'product'">Account</th>
            <th>Location</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.invoiceDate | date:'MM/dd/YYYY'}}</td>
            <td style="cursor: pointer; color: #517fa4;" (click)="onRouteNavigation('invoice',product)">{{product.invoiceId}}</td>
            <td>{{product.orderQty  | customNumberFormat: qtyDecimal }}</td>
            <td>{{product.shippedQty | customNumberFormat: qtyDecimal }}</td>
            <td>{{product.cost | customNumberFormat: decimalPlaces | currencySymbol}}</td>
            <td>{{product.salePrice | customNumberFormat: decimalPlaces | currencySymbol}}</td>
            <td *ngIf="module == 'product'" style="cursor: pointer; color: #517fa4;" (click)="onRouteNavigation('account',product)">{{product.account}}</td>
            <td style="cursor: pointer; color: #517fa4;" (click)="onRouteNavigation('location',product)">{{product.location}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="p-text-center">
                {{noSalesFindOrLoadingText}}
            </td>
        </tr>
    </ng-template>
</p-table>

    <app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>

<app-edit-account *ngIf="displayAccountViewEdit" [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
    [selectedAccountId]="selectedAccountId" [selectedChannelId]="selectedAccountChannelId"
    (closeModal)="closeAccountViewEditModal()"> </app-edit-account>